enum HttpStatus {
  START_DATE_NO_LONGER_AVAILABLE = 498,
  START_DATE_IN_THE_PAST = 499,
}

export { HttpStatus }
